export default __webpack_public_path__ + "static/media/discord.58ce875c.png";